<template>
  <div class="d-flex flex-column" style="min-height: 100vh">
    <!-- content -->
    <div style="flex: 1">
      <b-container fluid>
        <!-- header -->
        <b-container class="mt-3 mb-3">
          <b-row class="justify-content-center">
            <b-col cols="12" class="text-center">
              <img
                :src="require('@/assets/fbo_platform.png')"
                alt="FBO Platform"
                style="width: 100%; height: auto"
              />
            </b-col>
          </b-row>
        </b-container>
        <!-- header -->

        <!-- tools -->
        <b-container class="my-4">
          <b-row class="justify-content-center">
            <b-col
              v-for="tool in tools"
              :key="tool.id"
              cols="12"
              xs="6"
              sm="6"
              md="4"
              lg="3"
              class="mb-4"
            >
              <b-card-group deck>
                <b-link
                  v-if="tool.route.startsWith('http')"
                  :href="tool.route"
                  target="_blank"
                >
                  <b-card
                    :img-src="tool.image"
                    :img-alt="tool.alt"
                    img-top
                    tag="article"
                    class="tool-card mb-2"
                    no-body
                  >
                  </b-card>
                </b-link>
                <b-link v-else :to="tool.route">
                  <b-card
                    :img-src="tool.image"
                    :img-alt="tool.alt"
                    img-top
                    tag="article"
                    class="tool-card mb-2"
                    no-body
                  >
                  </b-card>
                </b-link>
              </b-card-group>
            </b-col>
          </b-row>
        </b-container>
        <!-- tools -->
      </b-container>
    </div>
    <!-- content -->
    <!-- footer -->
    <footer_page> </footer_page>
    <!-- footer -->
  </div>
</template>

<script>
import footer_page from "./footer_page.vue";
export default {
  data() {
    return {
      tools: [
        {
          id: 1,
          image: require("@/assets/online_shopping.png"),
          alt: "online_shopping",
          route: "https://foreverliving.com/hkg/zh-hk/home",
        },
        {
          id: 2,
          image: require("@/assets/room_booking.png"),
          alt: "room booking",
          route: "/login",
        },
        {
          id: 3,
          image: require("@/assets/cc_calculator.png"),
          alt: "case credit calculator",
          route: "/case_credit_calculator",
        },
        {
          id: 4,
          image: require("@/assets/latest_news.png"),
          alt: "latest news",
          route: "/notice",
        },
        {
          id: 5,
          image: require("@/assets/web_tips.png"),
          alt: "web_tips",
          route: "/web_tips",
        },
        {
          id: 6,
          image: require("@/assets/reward_program.png"),
          alt: "reward_program",
          route: "/reward_program",
        },
        {
          id: 7,
          image: require("@/assets/source_download.png"),
          alt: "source_download",
          route: "/source_download",
        },
      ],
    };
  },
  components: { footer_page },
};
</script>

<style scoped>
.tool-card {
  max-width: 100%;
  transition: transform 0.2s ease-in-out;
  cursor: pointer;
}

.tool-card:hover {
  transform: scale(1.2);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
}
</style>
